<template>
  <div v-if="organisations !== undefined">
    <template>
      <div
        class="mx-auto"
        v-on:click="handleContentClick($event)"
      >
        <div class="organisation desktop-container">
          <FavouritesButton
            :item="organisations"
            :type="'org'"
          />

          <img v-if="organisations._attachments" class="headline__img " :src="'data:' + organisations._attachments.image.content_type + ';base64,' + organisations._attachments.image.data" alt="" />

          <v-card-title class="pt-8">
            <h1 class="display-1 headline">{{organisations.name}}</h1>
          </v-card-title>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="pb-1">
                {{hubbdata.catagories.about}}
              </v-list-item-subtitle>
              <div v-html="organisations.description"></div>
            </v-list-item-content>
          </v-list-item>

          <v-list class="organisation__list" two-line>
            <v-list-item class="organisation__list-item" v-if="organisations.telephone !== null && organisations.telephone !== ''">
              <v-list-item-icon>
                <v-icon color="icons">mdi-phone</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{hubbdata.catagories.phone}}
                </v-list-item-subtitle>
                <v-list-item-title><a :href="'tel:' + organisations.telephone">{{organisations.telephone}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="organisation__list-item" v-if="organisations.email !== null  && organisations.email !== ''">
              <v-list-item-icon>
                <v-icon color="icons">mdi-email</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{hubbdata.catagories.email}}
                </v-list-item-subtitle>
                <v-list-item-title><a :href="'mailto:' + organisations.email">{{organisations.email}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="organisation__list-item" v-if="organisations.website_url !== null">
              <v-list-item-icon>
                <v-icon color="icons">mdi-earth</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{hubbdata.catagories.website}}
                </v-list-item-subtitle>
                <v-list-item-title v-if="linkSet(organisations.website_url)"><a :href="organisations.website_url">{{organisations.website_url}}</a></v-list-item-title>
                <v-list-item-title v-else><a :href="'http://' + organisations.website_url">{{organisations.website_url}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="organisation__list-item" v-if="organisations.address_1 !== null && organisations.address_1 !== ''">
              <v-list-item-icon>
                <v-icon color="icons">mdi-map-marker</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{hubbdata.catagories.address}}
                </v-list-item-subtitle>
                <v-list-item-title>{{organisations.address_1}}</v-list-item-title>
                <v-list-item-subtitle>{{organisations.address_2}}, {{organisations.town}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <GmapMap
          :center="{lat:organisations.latitude, lng:organisations.longitude}"
          :zoom="10"
          v-if="organisations.latitude"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
        >
          <GmapMarker
            ref="marker"
            :position="{ lat: organisations.latitude, lng: organisations.longitude }"
          />
        </GmapMap>
        
        <WasThisUseful
          :type="'orgs'"
        />
      </div>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful"
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';

export default {
  components: {
    WasThisUseful,
    FavouritesButton
  },
  computed: {
    organisations() {
      return hubbdata.getters.getOrganisationsById(this.$route.params.id)
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    linkSet(url) {
      if (url.indexOf("http") > -1){
        return true
      }
      else {
        return false
      }
    },
  },
  mounted: function() {
    if (this.organisations !== undefined) {
      ga('set', 'title', hubbdata.getters.getOrganisationsById(this.$route.params.id).name); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
    }
  },
}
</script>

<style lang="scss" scoped>
.organisation {

  .v-list-item__title,
  .v-list-item__subtitle {
    text-overflow: unset;
    white-space: unset;
  }

  &__list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    &:last-child {
      border-bottom: none;
    }
  }
}

.headline {
  word-break: normal;
  margin-right: 60px;

  &__img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
  }
}
</style>